import { render, staticRenderFns } from "./previewEdit.vue?vue&type=template&id=2100554b&scoped=true&"
import script from "./previewEdit.vue?vue&type=script&lang=js&"
export * from "./previewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2100554b",
  null
  
)

export default component.exports